import { render } from "./p404.vue?vue&type=template&id=08b7c67b&scoped=true"
import script from "./p404.vue?vue&type=script&lang=js"
export * from "./p404.vue?vue&type=script&lang=js"

import "./p404.vue?vue&type=style&index=0&id=08b7c67b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b7c67b"]])

export default __exports__